export default "__VITE_ASSET__BOFJPiW___"